export default __webpack_public_path__ + "static/media/f0df3cb6-6060-4f67-aeb1-e2fc7fdbc859.416e57aa.jpg";